<template>
  <div class="event-log text-dark pad-10">
    <h2 class="marg-10-bottom event-log__header">{{ i18n[locale]['latest_activity'] }}</h2>
    <div class="el-items">
      <Loader v-if="isLoading" bg-color="#f6f9fc"></Loader>
      <div v-for="activity in logsFormatted"
           class="el-items__item marg-10-bottom">
        <div class="el-info">
          <div class="el-info-right">
            <div class="el-info__headline">
              <p><b>{{activity.by}}</b></p>
              <p class="text-grey hint--top-left"
                 :aria-label="activity.vFormattedDate">
                {{ activity.vDuration }} {{ i18n[locale].ago }}</p>
            </div>
            <div class="el-items__item__changes" v-if="activity.changes">
              <p v-for="txt in activity.vHumanizedChanges" v-html="txt"></p>
            </div>
            <div class="el-items__item__changes" v-else>
              <p>{{ i18n[locale]['created'] }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isLoading && sortedLogs.length < 1">
        {{ i18n[locale]['no_changes'] }}
      </div>
    </div>
  </div>
</template>

<script>
  import Loader from '../common/Loader'
  import moment from 'moment'
  import docendo from '../../docendo'

  export default {
    name: 'eventChanges',
    components: {Loader},
    props: {
      eventId: {
        type: Number,
        default: 11794195
      },
      event: {
        default: null
      }
    },
    data () {
      return {
        i18n: {
          da: {
            latest_activity: 'Seneste aktivitet',
            no_changes: 'Ingen ændringer foretaget',
            created: 'Oprettede',
            added_room: 'Tilføjede lokale',
            removed_room: 'Fjernede lokale',
            added_user: 'Tilføjede person',
            removed_user: 'Fjernede person',
            changed_time: 'Ændrede tidspunkt',
            ago: 'siden',
            added_grade: 'Tilføjede klasse',
            removed_grade: 'Fjernede klasse',
            added_sub: 'Tilføjede vikar',
            removed_sub: 'Fjernede vikar',
            learning_goal_changed: 'Læringsmål ændrede',
            content_changed: 'Indhold ændrede',
            teacher_notes_changed: 'Vikarnoter ændrede',
            notes_for_students_changed: 'Noter til elever ændrede'
          },
          en: {
            latest_activity: 'Recent activity',
            no_changes: 'No changes made',
            created: 'Created',
            added_user: 'Added teacher',
            added_room: 'Added room',
            removed_user: 'Removed the teacher',
            changed_time: 'Changed time',
            ago: 'ago',
            added_grade: 'Added grade/group',
            removed_grade: 'Removed grade/group',
            added_sub: 'Added substitute',
            removed_sub: 'Removed substitute',
            learning_goal_changed: 'Learning goal changed',
            content_changed: 'Content changed',
            teacher_notes_changed: 'Teacher notes changed',
            notes_for_students_changed: 'Notes for students changed'
          },
          nb: {
            latest_activity: 'Historikk',
            no_changes: 'Ingen endringer er blitt gjort',
            created: 'Opprettet',
            added_room: 'La til lokalet',
            removed_room: 'Fjernet lokalet',
            added_user: 'La til underviser',
            removed_user: 'Fjernet underviseren',
            changed_time: 'Endret tiden',
            ago: 'siden',
            added_grade: 'La til klasse',
            removed_grade: 'Fjernet klasse',
            added_sub: 'La til vikar',
            removed_sub: 'Fjernet vikar',
            learning_goal_changed: 'Læringsmål endret',
            content_changed: 'Innhold endret',
            teacher_notes_changed: 'Vikarnotater endret',
            notes_for_students_changed: 'Notater for elever endret'
          }
        },
        isLoading: true,
        changes: []
      }
    },
    computed: {
      locale () {
        return this.$store.getters.locale
      },
      changesFiltered () {
        return this.changes.filter(change => change)
      },
      sortedLogs () {
        return this.changesFiltered.sort((a, b) => {
          if (b && b.at && a && a.at) {
            return new Date(b.at) - new Date(a.at)
          }
        })
      },
      logsFormatted () {
        return this.sortedLogs.map(activity => {
          return {
            ...activity,
            vFormattedDate: this.formatDate(activity.at),
            vDuration: this.getDuration(activity.at),
            vHumanizedChanges: this.humanizeChanges(activity.changes)
          }
        })
      }
    },
    methods: {
      formatDate (datetime) {
        return datetime ? moment(datetime).format('LLL') : datetime
      },
      getDuration (datetime) {
        let diff = moment().diff(moment(datetime))
        return moment.duration(diff).humanize()
      },
      changeCalendars (change) {
        let text = ''
        // var roomsChanges = '<b>Lokale ændringer</b><br>Fjernet lokale: <br> Tilføjet lokalet: ' + rooms.added
        let addedArr = change.calendars.addded
        let removedArr = change.calendars.removed
        // let klasses = []
        let users = {added: [], removed: []}
        let rooms = {added: [], removed: []}
        let subs = {added: [], removed: []}
        let klasses = {added: [], removed: []}

        addedArr.forEach(obj => {
          if (obj.type === 'room') {
            rooms.added.push(obj)
          }
          if (obj.type === 'user' && obj.substitute === null) {
            users.added.push(obj)
          }
          if (obj.type === 'user' && obj.substitute !== null) {
            subs.added.push(obj)
          }
          if (obj.type === 'klass') {
            klasses.added.push(obj)
          }
        })
        removedArr.forEach(obj => {
          if (obj.type === 'room') {
            rooms.removed.push(obj)
          }
          if (obj.type === 'klass') {
            klasses.removed.push(obj)
          }
          if (obj.type === 'user' && obj.substitute === null) {
            users.removed.push(obj)
          }
          if (obj.type === 'user' && obj.substitute !== null) {
            subs.removed.push(obj)
          }
        })
        if (rooms.added.length > 0) {
          const i18nRoomChanges = '<b><span class="icon-location"></span> ' + this.i18n[this.locale]['added_room'] + '</b>'
          let roomNames = rooms.added.map(obj => obj.name).join(', ')
          text = i18nRoomChanges + ' ' + roomNames + '<br>'
        }
        if (rooms.removed.length > 0) {
          const i18n = '<b><span class="icon-location"></span> ' + this.i18n[this.locale]['removed_room'] + '</b>'
          let names = rooms.removed.map(obj => obj.name).join(', ')
          text = text + i18n + ' ' + names + '<br>'
        }
        if (users.added.length > 0) {
          const i18n = '<b><span class="icon-user"></span> ' + this.i18n[this.locale]['added_user'] + '</b>'
          let userNames = users.added.map(obj => obj.name).join(', ')
          text = text + i18n + ' ' + userNames + '<br>'
        }
        if (users.removed.length > 0) {
          const i18n = '<b><span class="icon-user"></span> ' + this.i18n[this.locale]['removed_user'] + '</b>'
          let userNames = users.removed.map(obj => obj.name).join(', ')
          text = text + i18n + ' ' + userNames
        }
        if (klasses.added.length > 0) {
          const i18n = '<b><span class="icon-calendar4"></span> ' + this.i18n[this.locale]['added_grade'] + '</b>'
          let names = klasses.added.map(obj => obj.name).join(', ')
          text = i18n + ' ' + names + '<br>'
        }
        if (klasses.removed.length > 0) {
          const i18n = '<b><span class="icon-calendar4"></span> ' + this.i18n[this.locale]['removed_grade'] + '</b>'
          let names = klasses.removed.map(obj => obj.name).join(', ')
          text = text + i18n + ' ' + names + '<br>'
        }
        if (subs.added.length > 0) {
          const i18n = '<b><span class="icon-users"></span> ' + this.i18n[this.locale]['added_sub'] + '</b>'
          let userNames = subs.added.map(obj => obj.name).join(', ')
          text = text + i18n + ' ' + userNames + '<br>'
        }
        if (subs.removed.length > 0) {
          const i18n = '<b><span class="icon-users"></span> ' + this.i18n[this.locale]['removed_sub'] + '</b>'
          let userNames = subs.removed.map(obj => obj.name).join(', ')
          text = text + i18n + ' ' + userNames
        }
        return text
      },
      changeLearningGoalNotes (changes) {
        let txt = '<b><span class="icon-pencil"></span>' + this.i18n[this.locale]['learning_goal_changed'] + '</b>'
        let from = changes.learning_goal.from.length < 1 ? '' : changes.learning_goal.from
        let to = changes.learning_goal.to
        return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>'
      },
      changeDescNotes (changes) {
        let txt = '<b><span class="icon-pencil"></span>' + this.i18n[this.locale]['content_changed'] + '</b>'
        let from = changes.description.from.length < 1 ? '' : changes.description.from
        let to = changes.description.to
        return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>'
      },
      changeTeacherNotes (changes) {
        let txt = '<b><span class="icon-pencil"></span>' + this.i18n[this.locale]['teacher_notes_changed'] + '</b>'
        let from = changes.teacher_notes.from.length < 1 ? '' : changes.teacher_notes.from
        let to = changes.teacher_notes.to
        return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>'
      },
      changeNotesForStudents (changes) {
        let txt = '<b><span class="icon-pencil"></span> ' + this.i18n[this.locale]['notes_for_students_changed'] + '</b>'
        let from = changes.notes_for_students.from.length < 1 ? '' : changes.notes_for_students.from
        let to = changes.notes_for_students.to
        return '<b>' + txt + '</b><div>' + from + ' <span><b>&#8594;</b></span> ' + to + '</div>'
      },
      changeTime (changes) {
        let txt = '<b><span class="icon-clock"></span> ' + this.i18n[this.locale]['changed_time'] + '</b>'
        let oldStartTime = moment(changes.start.start.from).format('dddd LT')
        let newStartTime = moment(changes.start.start.to).format('dddd LT')
        let oldEndTime = moment(changes.end.end.from).format('LT')
        let newEndTime = moment(changes.end.end.to).format('LT')
        return '<b>' + txt + '</b><br>' + oldStartTime + ' - ' + oldEndTime + ' <span><b>&#8594;</b></span>  ' + newStartTime + ' - ' + newEndTime
      },
      changeStart (changes) {
        let txt = '<b><span class="icon-clock"></span> Ændrede start</b>'
        let oldStartTime = moment(changes.start.from).format('dddd LT')
        let newStartTime = moment(changes.start.to).format('dddd LT')
        return '<b>' + txt + '</b> Fra ' + oldStartTime + ' til ' + newStartTime
      },
      changeEnd (changes) {
        let txt = '<b><span class="icon-clock"></span> Ændrede slut</b>'
        let oldEndTime = moment(changes.end.from).format('dddd LT')
        let newEndTime = moment(changes.end.to).format('dddd LT')
        return '<b>' + txt + '</b> Fra ' + oldEndTime + ' til ' + newEndTime
      },
      humanizeChanges (lessonChanges) {
        let txt = []
        if (lessonChanges) {
          for (let i = 0; i < lessonChanges.length; i++) {
            switch (Object.keys(lessonChanges[i])[0]) {
              case 'learning_goal':
                txt.push(this.changeLearningGoalNotes(lessonChanges[i]))
                break
              case 'description':
                txt.push(this.changeDescNotes(lessonChanges[i]))
                break
              case 'teacher_notes':
                txt.push(this.changeTeacherNotes(lessonChanges[i]))
                break
              case 'notes_for_students':
                txt.push(this.changeNotesForStudents(lessonChanges[i]))
                break
              case 'calendars':
                txt.push(this.changeCalendars(lessonChanges[i]))
                break
              case 'start':
                // see if end is also changed
                if (lessonChanges[i + 1] && lessonChanges[i + 1].end) {
                  txt.push(this.changeTime({start: lessonChanges[i], end: lessonChanges[i + 1]}))
                } else {
                  txt.push(this.changeStart(lessonChanges[i]))
                }
                break
              case 'end':
                // see if start is also changed
                if (lessonChanges[i - 1] && lessonChanges[i - 1].start) {
                  break
                } else {
                  txt.push(this.changeEnd(lessonChanges[i]))
                }
                break
              default:
                txt.push('Changed something')
            }
          }
        }
        return txt
      }
    },
    mounted () {
      const schoolId = window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.event.school_id
      docendo.eventChanges(schoolId, this.eventId, data => {
        this.isLoading = false
        this.changes = data && data.length > 0 ? JSON.parse(data) : []
      })
    }
  }
</script>

<style scoped>
  .el-info {
    display: flex;
  }

  .el-info-left img {
    height: 35px;
  }

  .el-info-right {
    width: 100%;
  }

  .el-info__headline {
    display: flex;
    justify-content: space-between;
  }

  .el-items__item__changes {
    font-style: italic;
    color: #999;
  }

  .event-log__header {
    background: #f6f7f8;
    padding: 10px 10px;
    border-radius: 3px 3px 0 0;
    margin: -15px -15px 20px -15px;
  }
</style>



// WEBPACK FOOTER //
// EventChanges.vue?0342ce86